exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".uu5-bricks-youtube-video {\n  border: none;\n}\n.uu5-bricks-youtube-video-xs {\n  height: 315px;\n  width: 560px;\n}\n.uu5-bricks-youtube-video-sm {\n  height: 360px;\n  width: 640px;\n}\n.uu5-bricks-youtube-video-md {\n  height: 480px;\n  width: 853px;\n}\n.uu5-bricks-youtube-video-lg {\n  height: 720px;\n  width: 1280px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/less-loader/dist!./bricks/youtube-video.less
// module id = 286
// module chunks = 0